// extracted by mini-css-extract-plugin
export default {"errorMessage":"CreateAssessment_errorMessage__-oD4P"};